module.exports = __webpack_public_path__ + "img/047.96a179ed.jpg";